export default "__VITE_ASSET__wZroILv5__"